<section>
  <div class="signin-content d-flex">
    <div class="v_image flex-column justify-content-center align-items-center">
      <figure>
        <img src="https://d2abnqj5vuy2s4.cloudfront.net/assets/images/signin-image.jpg" alt="sing up image"
          style="max-width: 15rem; width: 100%; object-fit: contain" />
      </figure>
    </div>
    <div class="d-flex flex-column justify-content-around align-items-center signin-form-container">
      <figure>
        <img src="assets/images/virsa-black-logo.png" alt="sing up image"
          style="width: 100%; height: 4rem; object-fit: contain" />
      </figure>
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="d-flex flex-column gap-4 align-items-center">
        <div class="form-group">
          <label for="your_name" class="form-label">Enter Your Number or Email</label>
          <input type="text" name="your_name" id="your_name" class="form-input" placeholder="Mobile Number / Email"
            formControlName="your_name" />
        </div>
        <div class="d-flex flex-row gap-3">
          <input type="checkbox" formControlName="agreeTerm" />
          <label for="agreeTerm" class="label-agree-term" style="color: #4b4a4a;">
            Get notifications on whatsapp
          </label>
        </div>
        <div class="form-group form-button">
          <input type="submit" name="signin" id="signin" class="btnGlobal--secondary" value="Log in"
            [disabled]="!loginForm.valid || !isButtonOn" />
        </div>
      </form>
    </div>
  </div>
</section>